import React from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { changeSubject, signout, startMyExam } from '../actions';
// import history from '../history';
import katex from "katex";
import ReactQuill from "react-quill";

import "katex/dist/katex.min.css";
import "./Quill.css";

window.katex = katex;

const Welcome = props => {
    const history = useHistory();
    const {candidate} = props;
    if (props.candidate.examSuspended) props.signout();
    if (props.candidate.status === "Started" && !props.candidate.examSuspended) {
        history.push(`/exams/${candidate.id}`)
    }
    const renderSubjects = () => {
        return candidate.subjects?.map( subject => {
            return <li key={subject.integerCode}>{subject.name}</li>
        });
    }
    localStorage.setItem('currentSubject', JSON.stringify(candidate.subjects[0]));

    const startCandidateExam = () => { props.startMyExam(candidate.id); }

    return(

        <React.Fragment>
            {/* <!-- Page Heading --> */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 className="h5 mb-0 text-gray-800">{candidate.sessionCode} / Session {candidate.session}</h1>
                {/* <a href="#" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm"><i className="fas fa-download fa-sm text-white-50"></i> Generate Report</a> */}
            </div>

            <div className="row">

                {/* <!-- Student Details --> */}
                <div className="col-xl-3 col-md-3 mb-4">
                    <div className="card border-left-primary shadow h-100 py-2">
                        <img 
                            className="img-profile rounded-circle card-img-top" 
                            alt={candidate.registrationNumber} 
                            src={candidate.photo || "/img/default.png"}
                            onError={(e) => {
                                e.target.src = "/img/default.png";
                            }}
                        />
                        <div className="card-body">
                            <h6 className='card-title'>{candidate.name}</h6>
                            <h6>{candidate.registrationNumber}</h6>
                            <p><span className='font-weight-bold'>Exam Duration:</span> 
                                {Math.floor(candidate.durationInMinutes/60)}hours {candidate.durationInMinutes % 60}mins
                            </p>
                            <ul className='font-weight-bold text-uppercase text-success'>{renderSubjects()}</ul>
                        </div>
                    </div>
                </div>

                {/* <!--  Instructions --> */}
                <div className="col-xl-6 col-md-6 mb-4">
                    <div className="card border-left-success shadow h-100 py-2">
                        <div className="card-body">
                            <h5 className='card-title'>Exam Instructions</h5>
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <ReactQuill value={props.examInstructions} readOnly={true} />
                                </div>
                            </div>
                            <div className='text-center'>
                                <button disabled={props.isLoading} onClick={startCandidateExam} className='btn btn-success'>
                                    {props.isLoading ? 'Processing' : 'Start Exam'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!--  Keyboad Shortcuts --> */}
                <div className="col-xl-3 col-md-3 mb-4">
                    <div className="card border-left-success shadow h-100 py-2">
                        <div className="card-body">
                            <h5 className='card-title'>Keyboard Usage</h5>
                            <div className="row no-gutters align-items-center">
                                {/* <div className="col mr-2"> */}
                                    <ul className="list-group list-group-flush">
                                        <li className="list-group-item"><span className='btn btn-sm btn-info'>A</span> Option A</li>
                                        <li className="list-group-item"><span className='btn btn-sm btn-info'>B</span> Option B</li>
                                        <li className="list-group-item"><span className='btn btn-sm btn-info'>C</span> Option C</li>
                                        <li className="list-group-item"><span className='btn btn-sm btn-info'>D</span> Option D</li>
                                        <li className="list-group-item"><span className='btn btn-sm btn-info'>N</span> OR <span className='btn btn-sm btn-info'><i className='fas fa-arrow-right'></i></span> Next/Forward</li>
                                        <li className="list-group-item"><span className='btn btn-sm btn-info'>P</span> OR <span className='btn btn-sm btn-info'><i className='fas fa-arrow-left'></i></span> Previous/Back</li>
                                        <li className="list-group-item"><span className='btn btn-sm btn-info'><i className='fas fa-arrow-up'></i></span> Move Up</li>
                                        <li className="list-group-item"><span className='btn btn-sm btn-info'><i className='fas fa-arrow-down'></i></span> Move Down</li>
                                        <li className="list-group-item"><span className='btn btn-sm btn-danger'>S</span> Submit/End Exam</li>
                                    </ul>
                                {/* </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );


};

const mapStateToProps = state => {
    return {
        candidate: state.auth.user.data,
        examInstructions: state.auth.user.examInstructions,
        isLoading: state.utils.loading
    }
};

export default connect(mapStateToProps, {startMyExam, signout, changeSubject})(Welcome);